import { Icons } from '@agro-club/agroclub-shared'
import { useEventCount } from 'modules/socket/hooks'
import { OptionItem } from '../types'
import { useFilteredOptionsByPerms } from '../utils'
import { OPTIONS } from './CommonOptions'
import useMenuOptions from './useMenuOptions'

const DESKTOP_OPTIONS: OptionItem[] = [
  OPTIONS.US_CONTRACTS,
  OPTIONS.MATCHES,
  OPTIONS.SIGMA_DPR,
  OPTIONS.SIGMA_PL,
  OPTIONS.SIGMA_DAILY,
  OPTIONS.SIGMA_NEW_CONTRACTS,
  OPTIONS.SIGMA_UNSHIPPED,
  OPTIONS.DASHBOARD,
  OPTIONS.MY_TASKS,
  OPTIONS.TEAMS,
  OPTIONS.COMPANIES,
  OPTIONS.USERS,
  OPTIONS.BIDS,
  OPTIONS.DEALS,
  {
    key: 'allWarehouses',
    translateKey: 'locations',
    icon: <Icons.IconGarage />,
    children: [OPTIONS.WAREHOUSES, OPTIONS.ELEVATORS],
  },
  OPTIONS.SELLER_POTENTIAL,
  {
    key: 'newLogistics',
    translateKey: 'newLogistics',
    icon: <Icons.IconLocation />,
    eventModel: ['tripoffer', 'tripdocument'],
    children: [
      OPTIONS.LOGISTICS_DASHBOARD,
      OPTIONS.CARRIERS,
      OPTIONS.CARS,
      OPTIONS.PAYMENT_ORDERS,
      OPTIONS.RATES,
      OPTIONS.CUSTOMERS,
      OPTIONS.ADDRESSES,
    ],
  },
  OPTIONS.EXPORT,
  OPTIONS.DISPATCHING,
  {
    translateKey: 'calls',
    icon: <Icons.IconPhone />,
    key: 'calls',
    children: [OPTIONS.CALLS_LIST, OPTIONS.CALL_STATISTICS, OPTIONS.WHATS_APP],
  },
  OPTIONS.SPECIFICATIONS,
  OPTIONS.SAMPLES,
  {
    key: 'documents',
    icon: <Icons.IconGdprData />,
    translateKey: 'documents',
    eventModel: ['documentsrequest', 'salecontractrequest'],
    children: [OPTIONS.DOCUMENTS_LIST, OPTIONS.CONTRACTS, OPTIONS.SDIZ, OPTIONS.DOC_INDEX],
  },
]

export const useDesktopOptions = () => {
  const eventsCount = useEventCount()
  const filteredByPerms = useFilteredOptionsByPerms(DESKTOP_OPTIONS)

  const { menuOptions } = useMenuOptions(eventsCount, filteredByPerms)

  menuOptions.forEach((item) => {
    if (item.children?.length) {
      item.children = item.children.map(({ icon: _, ...rest }) => {
        return { ...rest }
      })
    }
  })

  return { menuOptions }
}
